/* eslint-disable no-console */
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      // App is being served from cache by a service worker.
    },
    registered() {
      // Service worker has been registered.
    },
    cached() {
      // Content has been cached for offline use.
    },
    updatefound() {
      // New content is downloading.
    },
    updated() {
      // New content is available; refresh to update.
    },
    offline() {
      // No internet connection; app is running in offline mode.
    },
    error(error) {
      console.error('Erreur service worker:', error)
    },
  })
}

